import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  BarElement,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

/**
 * One-time Chart.js registration for the statistics charts. Bars need the cartesian
 * scales + BarElement; the muscle-distribution radar needs the RadialLinearScale plus
 * point/line/fill elements. Importing this module performs the registration as a side
 * effect — chart components import it before rendering.
 */
ChartJS.register(
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  BarElement,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend,
);

/** Shared light-on-dark palette so every chart matches the portal's dark surface. */
export const CHART_TEXT_COLOR = "rgba(255, 255, 255, 0.75)";
export const CHART_GRID_COLOR = "rgba(255, 255, 255, 0.12)";
export const CHART_ACCENT = "#7c83ff";
export const CHART_ACCENT_SOFT = "rgba(124, 131, 255, 0.45)";
